/**
 * Utility for resolving product asset paths.
 *
 * Convention:
 *   frontend/public/products/{slug}/illustrations/{surface}.svg  — canvas backgrounds
 *   frontend/public/products/{slug}/mockups/{surface}.png        — default product previews
 *
 * Surface keys (camelCase from product config) are converted to kebab-case filenames.
 */

function toKebab(surface: string): string {
  return surface.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function getIllustrationPath(slug: string, surface: string): string {
  return `/products/${slug}/illustrations/${toKebab(surface)}.svg`;
}

export function getDefaultMockupPath(slug: string, surface: string): string {
  return `/products/${slug}/mockups/${toKebab(surface)}.png`;
}
